// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -531290073
// </auto-generated>
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { SmartListCriteria, SmartListResult } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';
import { Observable, Subject } from 'rxjs';

import { UploadObject } from '../shared/models/uploadobject';
import { ThirdPartyOrg } from './models/client/thirdpartyorg';
import { BlobResult } from './models/common/blobresult';
import { ActivitySummary } from './models/member/activitysummary';
import { Appointment } from './models/member/appointment';
import { Contact } from './models/member/contact';
import { Demographic } from './models/member/demographic';
import { Document } from './models/member/document';
import { Member } from './models/member/member';
import { MemberByPhone } from './models/member/memberbyphone';
import { MemberPlan } from './models/member/memberplan';
import { MemberPlanCoverage } from './models/member/memberplancoverage';
import { MemberSearch } from './models/member/membersearch';
import { MemberSsn } from './models/member/memberssn';
import { MemberSurgeryPlusStatus } from './models/member/membersurgeryplusstatus';
import { MemberValidate } from './models/member/membervalidate';
import { MemberCase } from './models/membercase/membercase';
import { ReimbursableService } from './models/membercase/reimbursableservice';
import { MedicalPlanCoverage } from './models/nonentity/medicalplancoverage';
import { MedicalPlanInformation } from './models/nonentity/medicalplaninformation';
import { MemberEmployeeNumber } from './models/nonentity/memberemployeenumber';
import { MemberPlanDesign } from './models/nonentity/memberplandesign';
import { PriorAuthorizationAndReward } from './models/nonentity/priorauthorizationandreward';
import { ProblematicMember } from './models/nonentity/problematicmember';
import { Team } from './models/security/team';
import { Vendor } from './models/vendor/vendor';
export interface getActivities_Filter {
  memberCaseId: string;
}

export interface getMembersByPhoneNumber_Filter {
  memberFirstName: string;
  memberLastName: string;
  memberBirthDate: string;
  memberSsn: string;
  memberEmployeeNumber: string;
  memberStatusId: number;
  memberClientId: string;
  memberPhoneNumber: string;
}

export interface getMemberCases_Filter {
  isFilterVoidAndIseligibleCases: boolean;
}

export interface findMembers_Filter {
  name: string;
}

export interface getFilteredMembers_Filter {
  memberFirstName: string;
  memberLastName: string;
  memberBirthDate: string;
  memberSsn: string;
  memberEmployeeNumber: string;
  memberStatusId: number;
  memberClientId: string;
  memberPhoneNumber: string;
}
export interface getFilteredMember_Filter {
  memberFirstName: string;
  memberLastName: string;
  memberSsn: string;
}

export interface generateEmployeeNumber_Filter {
  clientId: string;
}

export interface getMemberById_Filter {
  includeChildren: boolean;
}

export interface getDocuments_Filter {
  documentTypeId: number;
}

export interface getThirdPartyOrg_Filter {
  clientId: string;
}

export interface getFilteredMembersToValidate_Filter {
  memberFirstName: string;
  memberLastName: string;
  memberBirthDate: string;
  memberZipCode: string;
  memberStatusId: number;
}

@Injectable({
  providedIn: 'root',
})
export class MembersApiService {
  constructor(protected http: HttpClient) {}

  getMemberPlans(memberGuid: string): Observable<MemberPlan[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/plans`;
    return this.http.get<MemberPlan[]>(url);
  }

  getActivities(
    memberGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getActivities_Filter>
  ): Observable<SmartListResult<ActivitySummary>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/activities`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ActivitySummary>>(url, {
      params: params,
    });
  }

  getMembersByPhoneNumber(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getMembersByPhoneNumber_Filter>
  ): Observable<SmartListResult<MemberByPhone>> {
    let url = environment.chiliSauceApiRoot + `/api/Members/phone`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<MemberByPhone>>(url, {
      params: params,
    });
  }

  getMemberDemographics(
    memberGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Demographic>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/demographics`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Demographic>>(url);
  }

  updateMemberDemographics(
    memberAddress: Demographic,
    memberGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/demographics`;
    return this.http.put<any>(url, memberAddress);
  }

  getMemberReimbursableServices(
    memberGuid: string
  ): Observable<ReimbursableService[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/reimbursableservices`;
    return this.http.get<ReimbursableService[]>(url);
  }

  getPriorAuthorizationAndReward(
    memberGuid: string
  ): Observable<PriorAuthorizationAndReward> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/priorAuthorizationAndReward`;
    return this.http.get<PriorAuthorizationAndReward>(url);
  }

  getPartnerDetails(memberGuid: string): Observable<Vendor[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/getPartnerDetails`;
    return this.http.get<Vendor[]>(url);
  }
  getPlanCoverage(memberGuid: string): Observable<MedicalPlanCoverage[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/getPlanCoverage`;
    return this.http.get<MedicalPlanCoverage[]>(url);
  }

  updateMedicalPlanCoverage(
    planCoverageGuid: string,
    medicalPlanCoverage: MedicalPlanCoverage
  ): Observable<MedicalPlanCoverage> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${planCoverageGuid}/medicalPlanCoverages`;
    return this.http.put<MedicalPlanCoverage>(url, medicalPlanCoverage);
  }

  getNonInvoicedMemberReimbursableServices(
    memberCaseId: string,
    memberGuid: string
  ): Observable<ReimbursableService[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/noninvoicedreimbursableservices/${memberCaseId}`;
    return this.http.get<ReimbursableService[]>(url);
  }

  getMemberPlanDesign(memberGuid: string): Observable<MemberPlanDesign> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/memberPlanDesign`;
    return this.http.get<MemberPlanDesign>(url);
  }

  getMemberCases(
    memberGuid: string,
    queryParams?: Partial<getMemberCases_Filter>
  ): Observable<MemberCase[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/cases`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberCase[]>(url, { params: params });
  }

  getMedicalPlanInformation(
    memberGuid: string
  ): Observable<MedicalPlanInformation> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/getMedicalPlanInformation`;
    return this.http.get<MedicalPlanInformation>(url);
  }

  getMemberTeam(memberGuid: string): Observable<Team> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/team`;
    return this.http.get<Team>(url);
  }

  updateMemberPlanCoverage(
    memberPlanCoverage: MemberPlanCoverage,
    memberGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/memberPlanCoverages`;
    return this.http.put<any>(url, memberPlanCoverage);
  }

  addMemberPlanCoverage(
    planCoverageId: string,
    memberGuid: string
  ): Observable<MemberPlanCoverage> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/MemberPlan/${planCoverageId}`;
    return this.http.post<MemberPlanCoverage>(url, {});
  }

  getAllMembers(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Member>> {
    let url = environment.chiliSauceApiRoot + `/api/Members`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Member>>(url);
  }

  addMember(newMember: Member): Observable<Member> {
    const url = environment.chiliSauceApiRoot + `/api/Members`;
    return this.http.post<Member>(url, newMember);
  }

  findMembers(
    queryParams?: Partial<findMembers_Filter>
  ): Observable<MemberSearch[]> {
    const url = environment.chiliSauceApiRoot + `/api/Members/search`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberSearch[]>(url, { params: params });
  }

  getFilteredMembers(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFilteredMembers_Filter>
  ): Observable<SmartListResult<Member>> {
    let url = environment.chiliSauceApiRoot + `/api/Members/filtered`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Member>>(url, { params: params });
  }
  getFilteredMember(
    queryParams?: Partial<getFilteredMembers_Filter>
  ): Observable<Member> {
    debugger;
    let url = environment.chiliSauceApiRoot + `/api/Members/filteredMember`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Member>(url, { params: params });
  }
  getAppointments(memberGuid: string): Observable<Appointment[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/appts`;
    return this.http.get<Appointment[]>(url);
  }

  getMemberSsn(memberGuid: string): Observable<MemberSsn> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/ssn`;
    return this.http.get<MemberSsn>(url);
  }

  generateEmployeeNumber(
    queryParams?: Partial<generateEmployeeNumber_Filter>
  ): Observable<MemberEmployeeNumber> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/generate/employee-number`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberEmployeeNumber>(url, { params: params });
  }

  getMemberById(
    memberGuid: string,
    queryParams?: Partial<getMemberById_Filter>
  ): Observable<Member> {
    const url = environment.chiliSauceApiRoot + `/api/Members/${memberGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Member>(url, { params: params });
  }

  updateMember(member: Member, memberGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Members/${memberGuid}`;
    return this.http.put<any>(url, member);
  }

  addMemberDemographics(
    newdemographic: Demographic,
    memberGuid: string
  ): Observable<Demographic> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/Demographics`;
    return this.http.post<Demographic>(url, newdemographic);
  }

  addMemberDocuments(
    memberGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  getDocuments(
    memberGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getDocuments_Filter>
  ): Observable<SmartListResult<Document>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/documents`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Document>>(url, { params: params });
  }

  updateMemberProblematicInfo(
    memberGuid: string,
    member: ProblematicMember
  ): Observable<ProblematicMember> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/problematicInfo`;
    return this.http.put<ProblematicMember>(url, member);
  }

  getEligibilityDocument(memberGuid: string): Observable<Document> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/eligibilitydocument`;
    return this.http.get<Document>(url);
  }

  getThirdPartyOrg(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getThirdPartyOrg_Filter>
  ): Observable<SmartListResult<ThirdPartyOrg>> {
    let url = environment.chiliSauceApiRoot + `/api/Members/thirdpartyorg`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ThirdPartyOrg>>(url, {
      params: params,
    });
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/Members/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getContactsByMemberId(memberGuid: string): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/contacts`;
    return this.http.get<Contact[]>(url);
  }

  updateContactsForMemberId(
    memberGuid: string,
    contacts: Contact[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Members/${memberGuid}/contacts`;
    return this.http.put<any>(url, contacts);
  }

  getFilteredMembersToValidate(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFilteredMembersToValidate_Filter>
  ): Observable<SmartListResult<MemberValidate>> {
    let url = environment.chiliSauceApiRoot + `/api/Members/filteredToValidate`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<MemberValidate>>(url, {
      params: params,
    });
  }

  toggleMemberActiveStatus(memberGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/toggleMemberActiveStatus/${memberGuid}`;
    return this.http.put<any>(url, {});
  }
  getSplusMemberStatus(
    memberGuid: string
  ): Observable<MemberSurgeryPlusStatus> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Members/${memberGuid}/getMembersSplusStatus`;
    return this.http.get<MemberSurgeryPlusStatus>(url);
  }
}
